import { ActionTree } from 'vuex'

import { LogState, RootState } from '@/types/store'
import { ILog, LogParams } from '@/types/log'
import { UserRole } from '@/types/user'

import { createLog, getLogs, getProgresses, getNewProgresses } from '@/api/logs'

export const actions: ActionTree<LogState, RootState> = {
  async createLog(_, log: ILog): Promise<void> {
    await createLog(log)
  },
  async getLogs({ commit }, params: LogParams): Promise<void> {
    commit('setIsLogsLoading', true)
    const logs = await getLogs(params)
    commit('setIsLogsLoading', false)
    commit('logsLoaded', logs)
  },
  async getProgresses(
    { commit },
    {
      date,
      userRole,
      userId,
    }: { date: number; userRole: UserRole; userId: number },
  ): Promise<void> {
    commit('setIsProgressesLoading', true)
    const progresses = await getProgresses(date, userRole, userId)
    commit('setIsProgressesLoading', false)
    commit('progressesLoaded', progresses)
  },
  async getNewProgresses(
    { commit },
    {
      date,
      userRole,
      userId,
    }: { date: number; userRole: UserRole; userId: number },
  ): Promise<void> {
    commit('setIsProgressesLoading', true)
    const progresses = await getNewProgresses(date, userRole, userId)
    commit('setIsProgressesLoading', false)
    commit('newProgressesLoaded', progresses)
  },
  reset({ commit }): void {
    commit('setIsLogsLoading', false)
    commit('logsLoaded', [])
  },
}
